/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { OtpVerificaForm } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelPraticaCittadinoListItemDTO } from '../model/models';
import { PraticaCittadinoDetailDTO } from '../model/models';
import { PraticaCittadinoListFilter } from '../model/models';
import { PraticaCittadinoSubmitForm } from '../model/models';
import { PraticaCittadinoTimelineItemDTO } from '../model/models';
import { PraticaSubmitResponseDTO } from '../model/models';
import { PraticheCittadinoCountersDTO } from '../model/models';
import { PraticheCittadinoCountersFilter } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface CountPraticheCittadinoRequestParams {
    filter: PraticheCittadinoCountersFilter;
}

export interface GetPraticaCittadinoRequestParams {
    id: string;
}

export interface GetPraticaTimelineCittadinoRequestParams {
    id: string;
}

export interface ListPraticheCittadinoRequestParams {
    filter: PraticaCittadinoListFilter;
    pageable: Pageable;
}

export interface PatchPraticaCittadinoRequestParams {
    id: string;
    allParts: { [key: string]: Blob; };
    pratica: PraticaCittadinoSubmitForm;
}

export interface ReinviaOtpPraticaCittadinoRequestParams {
    id: string;
}

export interface SubmitPraticaCittadinoRequestParams {
    allParts: { [key: string]: Blob; };
    pratica: PraticaCittadinoSubmitForm;
}

export interface VerificaOtpPraticaCittadinoRequestParams {
    id: string;
    otpVerificaForm: OtpVerificaForm;
}


export interface CittadinoPraticheServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Conteggi per macro StatoPraticaCittadino. Stessi filtri della list eccetto stato.
     * 
     * @endpoint get /api/v1/cittadino/pratiche/counters
* @param requestParameters
     */
    countPraticheCittadino(requestParameters: CountPraticheCittadinoRequestParams, extraHttpRequestParams?: any): Observable<PraticheCittadinoCountersDTO>;

    /**
     * Detail form-shaped di una propria pratica. Body: {summary, form_data: {chiave→valore, anagrafica, nucleo}, capabilities: {can_edit, can_edit_reason?}}. Gli allegati sono esposti dall\&#39;endpoint dedicato /{id}/allegati (include il PDF originale come allegato SISTEMA).
     * 
     * @endpoint get /api/v1/cittadino/pratiche/{id}
* @param requestParameters
     */
    getPraticaCittadino(requestParameters: GetPraticaCittadinoRequestParams, extraHttpRequestParams?: any): Observable<PraticaCittadinoDetailDTO>;

    /**
     * Timeline delle transizioni di stato di una propria pratica. Whitelist server-side su event_type&#x3D;transizioni (8 valori). Ordine ASC. Non paginato (cardinalita\&#39; attesa &lt;20). Il commento operatore e\&#39; esposto solo sulle 4 transizioni terminali ACCETTATA/RIFIUTATA/VOUCHER_ASSEGNATI/VOUCHER_CONSEGNATI (privacy).
     * 
     * @endpoint get /api/v1/cittadino/pratiche/{id}/timeline
* @param requestParameters
     */
    getPraticaTimelineCittadino(requestParameters: GetPraticaTimelineCittadinoRequestParams, extraHttpRequestParams?: any): Observable<Array<PraticaCittadinoTimelineItemDTO>>;

    /**
     * Lista paginata delle proprie pratiche (cross-comune). Filtri opzionali: comune_slug, stato (macro StatoPraticaCittadino), tipo_pratica_id, tipologia, data_da, data_a (range inclusive su timestamp_richiesta). Sort fisso: timestamp_richiesta DESC. La riga lista include nucleo_familiare (nome/cognome/parentela) quando presente.
     * 
     * @endpoint get /api/v1/cittadino/pratiche
* @param requestParameters
     */
    listPraticheCittadino(requestParameters: ListPraticheCittadinoRequestParams, extraHttpRequestParams?: any): Observable<PagedModelPraticaCittadinoListItemDTO>;

    /**
     * Modifica una propria pratica in stato RICHIESTA_SOTTOMESSA su bandi con policy isModificaCittadinoPreLavorazioneEnabled&#x3D;true. Multipart: part \&#39;pratica\&#39; (JSON) + N part \&#39;allegato_&lt;target&gt;_&lt;chiave&gt;\&#39;. Genera nuovo OTP e transita a IN_ATTESA_OTP.
     * 
     * @endpoint patch /api/v1/cittadino/pratiche/{id}
* @param requestParameters
     */
    patchPraticaCittadino(requestParameters: PatchPraticaCittadinoRequestParams, extraHttpRequestParams?: any): Observable<PraticaSubmitResponseDTO>;

    /**
     * Reinvia un nuovo OTP per la pratica. Reset tentativi.
     * 
     * @endpoint post /api/v1/cittadino/pratiche/{id}/otp-reinvia
* @param requestParameters
     */
    reinviaOtpPraticaCittadino(requestParameters: ReinviaOtpPraticaCittadinoRequestParams, extraHttpRequestParams?: any): Observable<PraticaSubmitResponseDTO>;

    /**
     * Sottomette una nuova pratica per il bando selezionato. Multipart: part \&#39;pratica\&#39; (JSON) + N part \&#39;allegato_&lt;target&gt;_&lt;chiave&gt;\&#39;. Audience CITTADINO. Stato finale derivato da policy + strategia del bando.
     * 
     * @endpoint post /api/v1/cittadino/pratiche
* @param requestParameters
     */
    submitPraticaCittadino(requestParameters: SubmitPraticaCittadinoRequestParams, extraHttpRequestParams?: any): Observable<PraticaSubmitResponseDTO>;

    /**
     * Verifica OTP della pratica. TTL 15 min, max 3 tentativi prima di forzare reinvio.
     * 
     * @endpoint post /api/v1/cittadino/pratiche/{id}/otp-verifica
* @param requestParameters
     */
    verificaOtpPraticaCittadino(requestParameters: VerificaOtpPraticaCittadinoRequestParams, extraHttpRequestParams?: any): Observable<PraticaSubmitResponseDTO>;

}
